import { render, staticRenderFns } from "./ai-assistant-item.vue?vue&type=template&id=0d93698c&scoped=true"
import script from "./ai-assistant-item.vue?vue&type=script&lang=js"
export * from "./ai-assistant-item.vue?vue&type=script&lang=js"
import style0 from "./ai-assistant-item.vue?vue&type=style&index=0&id=0d93698c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93698c",
  null
  
)

export default component.exports